import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const renderValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

/**
 * One record, rendered as a card instead of a table row.
 *
 * fields  : [{ label, value }]        — the label/value rows in the body
 * badges  : [{ label, tone }]         — tone: 'success' | 'danger' | undefined
 */
const EntityCard = ({
  title,
  subtitle,
  code,
  avatar,
  selected = false,
  onSelect,
  fields = [],
  badges = [],
  viewTo,
  editTo,
  onView,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [avatarFailed, setAvatarFailed] = React.useState(false);

  return (
    <article className={`ad-card ${selected ? 'ad-card-selected' : ''}`}>
      <header className="ad-card-head">
        {onSelect && (
          <input
            type="checkbox"
            className="ad-checkbox"
            checked={selected}
            onChange={onSelect}
            aria-label={title}
          />
        )}
        {avatar !== undefined && (
          <span className="ad-card-avatar">
            {avatar && !avatarFailed ? (
              <img src={avatar} alt="" onError={() => setAvatarFailed(true)} />
            ) : (
              <i className="fas fa-building"></i>
            )}
          </span>
        )}
        <div className="ad-card-title-wrap">
          <h3 className="ad-card-title">{renderValue(title)}</h3>
          {subtitle && <p className="ad-card-subtitle">{subtitle}</p>}
        </div>
        {code && <span className="ad-card-code">{code}</span>}
      </header>

      {fields.length > 0 && (
        <div className="ad-card-body">
          {fields.map((field) => (
            <div key={field.label} className="ad-field">
              <span className="ad-field-label">{field.label}</span>
              <span className="ad-field-value">{renderValue(field.value)}</span>
            </div>
          ))}
        </div>
      )}

      <footer className="ad-card-foot">
        <div className="ad-badges">
          {badges.map((badge) => (
            <span
              key={badge.label}
              className={`ad-badge ${badge.tone ? `ad-badge-${badge.tone}` : ''}`}
            >
              {badge.label}
            </span>
          ))}
        </div>

        <div className="ad-card-actions">
          {/* A callback opens a dialog; a `To` prop navigates instead. */}
          {onView && (
            <button
              type="button"
              className="ad-card-action"
              onClick={onView}
              title={t('common.view')}
            >
              <i className="fas fa-eye"></i>
            </button>
          )}
          {!onView && viewTo && (
            <Link to={viewTo} className="ad-card-action" title={t('common.view')}>
              <i className="fas fa-eye"></i>
            </Link>
          )}
          {onEdit && (
            <button
              type="button"
              className="ad-card-action"
              onClick={onEdit}
              title={t('common.edit')}
            >
              <i className="fas fa-pen"></i>
            </button>
          )}
          {!onEdit && editTo && (
            <Link to={editTo} className="ad-card-action" title={t('common.edit')}>
              <i className="fas fa-pen"></i>
            </Link>
          )}
          {onDelete && (
            <button
              type="button"
              className="ad-card-action ad-card-action-danger"
              onClick={onDelete}
              title={t('common.delete')}
            >
              <i className="fas fa-trash"></i>
            </button>
          )}
        </div>
      </footer>
    </article>
  );
};

export default EntityCard;
